@if (isOpen) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-5"
    (click)="onBackdropClick($event)"
    >
    <div
      class="relative my-auto flex min-h-0 w-full flex-col overflow-hidden rounded-xl border border-slate300 bg-white shadow-sm"
      [ngClass]="[dialogWidthClass, dialogHeightClass, dialogPanelClass]"
      >
      @if (showCloseButton) {
        <button
          type="button"
          aria-label="Close popup"
          class="absolute right-3 top-2 z-10 flex h-8 w-8 items-center justify-center cursor-pointer font-bold rounded-full text-lg text-slate800 hover:bg-slate100"
          (click)="onClose()"
          >
          <svg viewBox="0 0 20 20" class="h-5 w-5 fill-none stroke-current" stroke-width="2">
            <path d="M5 5l10 10"></path>
            <path d="M15 5 5 15"></path>
          </svg>
        </button>
      }
      <div
        class="min-h-0 flex-1"
        [ngClass]="[bodyPaddingClass, bodyOverflowVisible ? 'overflow-visible' : 'overflow-y-auto']"
        >
        <ng-content></ng-content>
      </div>
      @if (showDefaultFooter) {
        <div class="shrink-0 border-t border-slate200 bg-white px-6 py-4">
          <app-button-reusable
            type="button"
            variant="neutral"
            appearance="outline"
            (clicked)="onClose()"
            >
            Cancel
          </app-button-reusable>
        </div>
      }
    </div>
  </div>
}
